import { createContext, useContext, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";
import { useQuery } from "@tanstack/react-query";
const AuthContext = createContext();

export const AuthProvider = ({ children, userData }) => {
  const [user, setUser] = useLocalStorage("user", userData);
  const userQuery = useQuery({
    queryKey: ["userData"],
    queryFn: () =>
      fetch("/api/users/me/", {
        credentials: "same-origin",
      }).then((res) => {
        if (res.status === 401) {
          console.error("Unauthorized access, redirecting to login");
          navigate("/login");
          return null;
        } else if (!res.ok) {
          throw new Error("Failed to fetch user data");
        }
        return res.json();
      }),
    });
  //const [user, setUser] = useState(userQuery.data);
  const navigate = useNavigate();

  // call this function when you want to authenticate the user
  const login = async (data) => {
    setUser(data);
    navigate("/admin");
  };

  // call this function to sign out logged in user
  const logout = () => {
    setUser(null);
    navigate("/", { replace: true });
  };

  const value = useMemo(
    () => ({
      user,
      login,
      logout,
    }),
    [user]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};